module.exports = __webpack_public_path__ + "img/public/SiteIcons/viewWrite.svg?5999ce6a";